import { useState, useEffect, useMemo } from 'react';
import { initialStateFactory } from './initialStateFactory';
import { useMethods } from './methods';
import { useVariables } from './variables';
export * from './types';
export const useTransferSelector = (service, parentState, isOpen) => {
    const [state, setState] = useState(initialStateFactory(service, parentState));
    const methods = useMethods(state, setState, service, parentState);
    const variables = useVariables(state, service);
    const [initialState, setInitialState] = useState(state);
    useEffect(() => {
        if (isOpen) {
            setInitialState(state);
        }
    }, [isOpen]);
    const isDirty = useMemo(() => {
        var _a, _b;
        for (const passengerId in state) {
            for (const serviceId in state[passengerId]) {
                if (((_a = state[passengerId][serviceId]) === null || _a === void 0 ? void 0 : _a.selected) !== ((_b = initialState[passengerId][serviceId]) === null || _b === void 0 ? void 0 : _b.selected)) {
                    return true;
                }
            }
        }
        return false;
    }, [state, initialState]);
    return {
        state,
        isDirty,
        setState,
        toggleService: methods.onToggle,
        restoreState: methods.restoreState,
        removeTransfer: methods.removeTransfer,
        totalPrice: variables.totalPrice,
        minPrice: variables.minPrice
    };
};
